// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".organizer-img[data-v-7576f7ec]{max-width:12rem}", ""]);
// Exports
module.exports = exports;
